var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "wine-bottle-375ml",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m48.639,27.444c-.556,0-1.006.454-1,1.011l.06,5.657c0,3.289-.333,4.702-.855,8.423-.591,4.214-2.961,11.315-3.325,12.585-.237.824-1.039,3.428-1.69,6.184-.548,2.322-1.006,4.701-1.026,7.087v18.136c.017.966.696,1.738,1.529,1.741h15.336c.833-.002,1.512-.774,1.529-1.741v-18.136c-.02-2.385-.477-4.765-1.026-7.087-.651-2.756-1.453-5.36-1.69-6.184-.365-1.27-2.734-8.371-3.325-12.585-.522-3.721-.855-4.988-.855-8.423l.06-5.657c.006-.556-.443-1.011-1-1.011h-2.723Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }